import styled, { css } from 'styled-components'
import { ifProp, prop, withProp } from 'styled-tools'
import PageTitleComponent from '../../components/page-title'
import Button from '../../components/Button'
import TextareaWithFloatingLabelComp from '../../components/form-fields/components/text-area-with-floating-label'
import { CustomSelect as CustomSelectComponent } from '../TeamManagementUsers/components/CustomSelect'
import { Textarea } from '../../components/input/styled-components'
import Input from '../../components/input'
import HelpCenterLink from '../../components/help-center-link'
import { SubSectionWrapper as SubSectionWrapperComp } from '../../components/breadcrumb/styled-components'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'
import SubmenuNew from '../../components/submenu-new'
import InputWithFloatingLabelComponent from '../../components/form-fields/components/form-field-input/input-with-floating-label'

export const PageTitle = styled(PageTitleComponent)`
  margin-bottom: 32px;
`

export const TeamsBreadcrumbBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 88px;
  align-items: center;
  padding: 16px;
  ${ifProp(
    'noBg',
    css`
      background-color: transparent;
      border-bottom: none;
    `,
    css`
      background-color: ${colorsOptions.greys.white};
      border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
    `
  )}
`

export const SubSectionWrapper = styled(SubSectionWrapperComp)`
  margin-right: -7px;
  width: 240px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const InviteMemberButton = styled(Button)`
  height: 40px;
  color: ${colorsOptions.docuToolsOrange.orange};
  border: 1px solid ${colorsOptions.docuToolsOrange.orange};
  min-width: 0;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${ifProp(
    'noMembers',
    css`
      align-self: flex-end;
      margin-right: 16px;
      background-color: ${colorsOptions.docuToolsOrange.orange};
      color: ${colorsOptions.greys.white};
    `
  )}
`

export const ProfileImageMobile = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  z-index: 1;
  position: relative;
  opacity: ${ifProp('inactive', 0.5, 1)};
  &::after {
    content: '';
    z-index: 1;
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    right: 1px;
    position: absolute;
    bottom: 0;
    ${ifProp(
      'bgColor',
      css`
        background-color: ${prop('bgColor')};
        border: 1px solid ${colorsOptions.greys.white};
      `
    )}
  }
  &::before {
    content: '';
    z-index: -1;
    border-radius: 32px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-position: 50% 50%;
    background-image:
      url('${prop('imageUrl')}'), url('${prop('defaultImage')}');
    background-size: cover;
    opacity: ${withProp('status', (status) => {
      if (['Inactive', 'Expired', 'Removed'].includes(status)) return '.5'
      return '1'
    })};
  }
`

export const GroupIcon = styled.div`
  display: flex;
  width: 50px;
  height: 50px;
  margin-right: 0.3em;
  flex: 0 0 auto;
  position: relative;
  align-items: center;
  &::after {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 9px;
    right: 13px;
    position: absolute;
    bottom: 6px;
    background-color: ${ifProp(
      'inactive',
      colorsOptions.secondaryColors.red.strong,
      colorsOptions.secondaryColors.green.strong
    )};
    border: 1px solid ${colorsOptions.greys.white};
  }
`

export const Hint = styled.p`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.greys['grey-60']};
  margin: 24px 16px 16px;
`

export const SectionBoxSizing = styled.section`
  margin: 16px;
`

export const SectionWrapper = styled(SectionBoxSizing)`
  background-color: ${colorsOptions.greys.white};
  padding: 16px;
`

export const SectionHint = styled(Hint)`
  color: ${colorsOptions.greys['grey-50']};
  margin: 0 0 5px;
`

export const TagSectionWrapper = styled(SectionWrapper)`
  & > div > div {
    border-radius: 8px;
  }
`

export const SectionHeader = styled.h4`
  margin-bottom: 16px;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
`

export const InviteMemberSectionHeader = styled(SectionHeader)`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  display: inline-block;
`

export const InviteMemberSectionHeaderHint = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-60']};
`

export const DropZoneWrapper = styled.div`
  display: flex;
  border: 1px dashed ${colorsOptions.greys['grey-30']};
  height: 88px;
  margin-top: 8px;
  padding-left: 16px;
  align-items: center;
`
export const ProfileImg = styled.div`
  width: ${prop('size', '64px')};
  height: ${prop('size', '64px')};
  border: 1px solid ${colorsOptions.greys['grey-60']};
  border-radius: 64px;
  background-image: url('${prop('imageUrl')}'), url('${prop('defaultImage')}');
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
`
export const UploadInstruction = styled.div`
  margin-left: 114px;
  width: 100%;
  color: ${colorsOptions.greys['grey-60']};
`

export const InputWithFloatingLabel = styled(InputWithFloatingLabelComponent)`
  input {
    border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  }
`

export const TextareaWithFloatingLabel = styled(TextareaWithFloatingLabelComp)`
  textarea {
    border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  }
`

export const UserProfileSectionWrapper = styled(SectionWrapper)`
  padding-right: 0;
`

export const RoleSectionWrapper = styled(SectionWrapper)`
  height: 100px;
`

export const CustomSelect = styled(CustomSelectComponent)`
  ul {
    left: 150px;
    right: initial;
    &:before {
      left: 14px;
      top: -10px;
    }
    &:after {
      left: 14px;
      top: -11px;
    }
  }
`

export const SelectFile = styled.button`
  color: ${colorsOptions.docuToolsOrange.orange};
  text-decoration: underline;
`

export const EmptyListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 96px;
`

export const EmptyIcon = styled.div`
  margin-bottom: 16px;
`

export const EmptyHeader = styled.h3`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  color: ${colorsOptions.greys['grey-60']};
  margin-bottom: 16px;
`

export const EmptySubHeader = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  max-width: 512px;
  text-align: center;
  color: ${colorsOptions.greys['grey-60']};
`
export const ReadMore = styled(HelpCenterLink)`
  color: ${colorsOptions.docuToolsOrange.orange};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  text-decoration: none;
`
export const ReadMoreLink = styled.a`
  color: ${colorsOptions.docuToolsOrange.orange};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  text-decoration: none;
`

export const MessageTitle = styled.span`
  color: ${colorsOptions.greys['grey-60']};
`

export const MessageTextArea = styled(Textarea)`
  border: 1px solid ${colorsOptions.greys['grey-30']};
  height: 96px;
  border-radius: 8px;
  padding: 16px;
`

export const PrivilegeSubtext = styled.div`
  color: ${colorsOptions.greys['grey-60']};
  margin-bottom: 16px;
`
export const PrivilegeCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 83px;
  justify-content: space-between;
`

export const PrivilegeLabel = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-left: 16px;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};

  & > span:nth-child(2) {
    ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
    color: ${colorsOptions.greys['grey-60']};
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  }
`
export const DropDownWrapper = styled.div`
  margin-bottom: 13px;
  & > span {
    display: block;
  }
  .Select__control {
    height: 30px;
    border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  }
  .Select__single-value {
    margin-left: 0;
  }
  .Select__single-value--is-disabled {
    color: ${colorsOptions.greys['grey-100']};
  }
  .Select__control--is-disabled {
    background-color: ${colorsOptions.greys.white};
  }
`

export const FullNames = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]};
  margin-top: 8px;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
`

export const Company = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-400']]};
`

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0 3px 0;
`

export const ProfileSubmenu = styled(SubmenuNew)`
  position: absolute;
  top: 24px;
  right: 24px;
`

export const ExpandButton = styled.button`
  border: none;
  margin-left: -7px;
  width: 40px;
  height: 40px;
  display: inline-block;
`

export const ConfirmPopupBody = styled.p`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  padding: 30px 18px 10px;
`

export const ConfirmPopupBody2 = styled(ConfirmPopupBody)`
  padding-top: 0;
  color: ${colorsOptions.secondaryColors.red.strong};
`

export const ConfirmReadMore = styled(ReadMore)`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
`

export const ListSubtitledLabel = styled.div`
  flex: 1 1 auto;
  display: inline-flex;
  width: calc(100% - 80px);
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: 100%;
  }
  & > :last-child {
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
    color: ${colorsOptions.greys['grey-60']};
  }
`

export const ListMemberCount = styled.div`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  color: ${colorsOptions.greys['grey-60']};
  & > img {
    margin-left: 0.3em;
    width: 16px;
  }
`

export const ListItemWrapper = styled.div`
  display: flex;
  position: relative;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  align-items: center;
  justify-content: space-between;
  padding: 1em;
  width: 100%;
  height: 56px;
  &:not(:last-child):after {
    content: '';
    position: absolute;
    margin: 0 1.5em;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  }
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
  & > img {
    flex: 0 0 auto;
  }
  ${ifProp(
    'disabled',
    css`
      pointer-events: none;
      &,
      & > ${ListMemberCount}, ${ListSubtitledLabel} > :nth-child(2) {
        color: ${colorsOptions.greys['grey-30']};
      }
      & img {
        opacity: 0.4;
      }
    `
  )}
  ${ifProp(
    'active',
    css`
      & > ${ListSubtitledLabel} {
        margin-left: -0.5em;
      }
      &,
      & > ${ListMemberCount}, ${ListSubtitledLabel} > :nth-child(2) {
        color: ${colorsOptions.docuToolsOrange.orange};
      }
      & > img:first-of-type {
        margin-left: -0.5em;
      }
    `
  )}
`

export const ListWrapper = styled.div`
  height: 100%;
  padding-bottom: 0.5em;
`

export const SearchInputWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  padding: 1.5em;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
`

export const SearchInput = styled(Input)`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  padding: 0;
`

export const InviteToTeamWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${colorsOptions.greys.white};
  height: 390px;
  position: relative;
`

export const EmptyMessage = styled.div`
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const ImportContactPopupWrapper = styled.div`
  padding: 15px 0 15px 16px;
`
export const headerBackground = {
  inlineStyle: {
    backgroundColor: colorsOptions.greys['grey-20'],
    color: colorsOptions.greys['grey-60']
  }
}

export const inviteMemberTableHeader = {
  backgroundColor: colorsOptions.greys['grey-20'],
  color: colorsOptions.greys['grey-60'],
  fontSize: '12px'
}

export const Row = styled.div`
  margin-top: 20px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DropZoneContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
`
